module.exports = __webpack_public_path__ + "static/media/NewDesignErro.5a5f229f.svg";